import {
  SECTION_ANCHORS,
  SECTION_LABELS,
  type LookbookSection,
} from "./lookbook-visibility";

/**
 * Jump links for a deal page that has more than one section.
 *
 * Anchors rather than tabs: the page keeps its sticky right rail and its
 * comment thread, both of which a tab bar would have to strand outside the
 * tabs or trap inside one. Most deals show one or two sections anyway, so tabs
 * would be chrome over nothing to switch between.
 */
export function LookbookSectionNav({
  sections,
}: {
  sections: LookbookSection[];
}) {
  if (sections.length < 2) return null;

  return (
    <nav className="sticky top-16 z-10 -mx-1 flex flex-wrap gap-2 bg-background/80 px-1 py-2 backdrop-blur">
      {sections.map((section) => (
        <a
          key={section}
          href={`#${SECTION_ANCHORS[section]}`}
          className="rounded-full border border-border bg-card px-3 py-1 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          {SECTION_LABELS[section]}
        </a>
      ))}
      <a
        href="#lb-comments"
        className="rounded-full border border-border bg-card px-3 py-1 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
      >
        Comments
      </a>
    </nav>
  );
}
